const mapGetters = require('vuex').mapGetters;
const mapMutations = require('vuex').mapMutations;

const translationsMixin = {
  methods: {
    ...mapMutations([
      'updateTranslations'
    ]),
    saveTranslations (key, translated) {
      this.updateTranslations({
        key: key,
        translated: translated
      });
    }
  },
  computed: {
    ...mapGetters([
      'getTranslations',
      'getTranslation'
    ])
  }
};

module.exports = translationsMixin;
